import { DonutData } from "@declarations";

export const getTotalAngles = (data: DonutData[]) => {
    return data.reduce((prev: number, current: DonutData): number => {
        return prev + current.angle;
    }, 0);

}